<template>
    <v-card class="ma-3 pa-5">
        <h3 class="calculation-title">Calculations</h3>

        <h4>Filters</h4>

        <v-simple-table dense class="custom-table-padding filter-bg">
            <tbody>
                <td class="index-textarea">
                    <v-textarea
                        rows="1"
                        placeholder="Formula"
                        auto-grow
                        flat
                        clearable
                        dense
                        solo
                        hide-details
                        v-model="calculationFilter.formula"
                    ></v-textarea>
                </td>
                <td>
                    <v-select
                        item-value="id"
                        item-text="locale.en_culture"
                        multiple
                        hide-details
                        clearable
                        dense
                        :items="tData"
                        label="Culture"
                        v-model="calculationFilter.culture"
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2">
                                <span>{{ item.locale.en_culture }}</span>
                            </v-chip>
                            <span v-if="index === 2" class="grey--text text-caption">
                                (+{{ calculationFilter.culture.length - 2 }} others)
                            </span>
                        </template>
                    </v-select>
                </td>
                <td>
                    <v-select
                        item-value="id"
                        item-text="name"
                        hide-details
                        dense
                        multiple
                        clearable
                        :items="soils"
                        placeholder="Soil types"
                        v-model="calculationFilter.soil_type"
                    >
                    </v-select>
                </td>
                <td>
                    <v-select
                        item-value="id"
                        item-text="code"
                        hide-details
                        dense
                        multiple
                        clearable
                        :items="countries"
                        placeholder="Countries"
                        v-model="calculationFilter.countries"
                    >
                    </v-select>
                </td>
                <td>
                    <v-menu
                        class="date-to-menu"
                        v-model="show_date_from_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                class="date-to-menu"
                                :value="calculationFilter.date_from ? formatDate(calculationFilter.date_from) : null"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                @click:clear="clearDate('from')"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            :show-current="false"
                            first-day-of-week="1"
                            v-model="calculationFilter.date_from"
                            @input="show_date_from_menu = false"
                        ></v-date-picker>
                    </v-menu>
                    <v-menu
                        class="date-to-menu"
                        v-model="show_date_to_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                class="date-to-menu"
                                :value="calculationFilter.date_to ? formatDate(calculationFilter.date_to) : null"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                @click:clear="clearDate('to')"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            :show-current="false"
                            clearable
                            first-day-of-week="1"
                            v-model="calculationFilter.date_to"
                            @input="show_date_to_menu = false"
                        ></v-date-picker>
                    </v-menu>
                </td>
                <td>
                    <v-select
                        item-value="id"
                        item-text="index"
                        hide-details
                        dense
                        clearable
                        :items="rec_data"
                        placeholder="Recommendation"
                        v-model="calculationFilter.recommendation"
                    />
                </td>
            </tbody>
        </v-simple-table>

        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left title-padding">
                            Index
                        </th>
                        <th class="text-left title-padding">
                            Formula
                        </th>
                        <th class="text-left">
                            Culture
                        </th>
                        <!--                    <th class="text-left">-->
                        <!--                        Sensor-->
                        <!--                    </th>-->
                        <th class="text-left">
                            Soil types
                        </th>
                        <th class="text-left">
                            Countries
                        </th>
                        <th class="text-left">
                            Timespan
                        </th>
                        <th class="text-left">
                            Recommendation
                        </th>
                        <th class="text-left">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="calculation in orderedCalculationData" :key="calculation.id">
                        <td class="index-textarea min-width-100">
                            <div v-if="calculation.duplicate">duplicate</div>
                            <v-textarea
                                class="index"
                                rows="1"
                                placeholder="Index"
                                auto-grow
                                flat
                                dense
                                solo
                                hide-details
                                v-model="calculation.index"
                            ></v-textarea>
                        </td>

                        <td class="min-width-400">
                            <v-textarea
                                rows="1"
                                placeholder="Formula"
                                auto-grow
                                flat
                                dense
                                solo
                                hide-details
                                v-model="calculation.formula"
                            ></v-textarea>
                        </td>

                        <td class="base-min-width">
                            <!--            <v-select item-value="id" item-text="locale.en_culture" multiple hide-details dense :items="tData" label="culture"-->
                            <!--                      v-model="calculation.culture"/>-->
                            <culture-select :calculation="calculation" />
                        </td>

                        <!--                    <td class="sensor-width">-->
                        <!--                        <v-checkbox-->
                        <!--                                dense-->
                        <!--                                hide-details-->
                        <!--                                :ripple="false"-->
                        <!--                                v-model="calculation.sensor_high"-->
                        <!--                                label="High"-->
                        <!--                        ></v-checkbox>-->
                        <!--                        <v-checkbox-->
                        <!--                                dense-->
                        <!--                                hide-details-->
                        <!--                                :ripple="false"-->
                        <!--                                v-model="calculation.sensor_low"-->
                        <!--                                label="Low"-->
                        <!--                        ></v-checkbox>-->
                        <!--                    </td>-->

                        <td class="base-min-width">
                            <v-select
                                item-value="id"
                                item-text="name"
                                hide-details
                                dense
                                multiple
                                :items="soils"
                                placeholder="Soil types"
                                v-model="calculation.soil_type"
                            />
                        </td>

                        <td class="base-min-width">
                            <v-select
                                item-value="id"
                                item-text="code"
                                hide-details
                                dense
                                multiple
                                :items="countries"
                                placeholder="Countries"
                                v-model="calculation.countries"
                            />
                        </td>

                        <td class="base-min-width">
                            <v-menu
                                class="date-to-menu"
                                v-model="calculation.show_date_from_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        class="date-to-menu date_style"
                                        :value="formatDate(calculation.date_from)"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :show-current="false"
                                    first-day-of-week="1"
                                    v-model="calculation.date_from"
                                    @input="calculation.show_date_from_menu = false"
                                />
                            </v-menu>
                            <v-menu
                                class="date-to-menu"
                                v-model="calculation.show_date_to_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        class="date-to-menu"
                                        :value="formatDate(calculation.date_to)"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :show-current="false"
                                    first-day-of-week="1"
                                    v-model="calculation.date_to"
                                    @input="calculation.show_date_to_menu = false"
                                ></v-date-picker>
                            </v-menu>
                        </td>

                        <td class="base-min-width">
                            <v-select
                                v-model="calculation.recommendation"
                                :hint="recommendationText(calculation.recommendation)"
                                :items="rec_data"
                                :menu-props="{
                                    closeOnClick: true,
                                    closeOnContentClick: true
                                }"
                                dense
                                item-subtitle="index"
                                item-text="index"
                                item-title="index"
                                item-value="id"
                                persistent-hint
                                placeholder="Recommendation"
                            >
                                <template v-slot:item="{ props, item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-list-item
                                                v-bind="props"
                                                @click="handleRecommendationItemClick(calculation, item)"
                                                v-on="on"
                                            >
                                                {{ item.index }}
                                            </v-list-item>
                                        </template>
                                        <span>{{ item.locale.en.text }}</span>
                                    </v-tooltip>
                                </template>
                            </v-select>
                        </td>
                        <td class="button-position base-min-width">
                            <v-icon class="mr-2" title="Edit calculation" @click="editCalculation(calculation)">
                                mdi-content-save-outline
                            </v-icon>
                            <v-icon
                                class="mr-2"
                                title="Refresh all calculation s"
                                @click="handleRefreshCalculationClick(calculation.id)"
                            >
                                mdi-refresh
                            </v-icon>
                            <v-icon
                                class="mr-2"
                                title="Duplicate calculation"
                                @click="duplicateCalculation(calculation)"
                            >
                                mdi-content-duplicate
                            </v-icon>
                            <v-icon class="mr-2" title="Delete calculation" @click="deleteCalculation(calculation)">
                                mdi-trash-can-outline
                            </v-icon>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import CalcTableCultureSelect from "./CalcTableCultureSelect";

export default {
    name: "CalculationListTable",
    components: { "culture-select": CalcTableCultureSelect },
    data() {
        return {
            soils: [],
            tData: [],
            field_culture: [],
            rec_data: [],
            orderedCalculationData: [],
            show_date_from_menu: false,
            show_date_to_menu: false
        };
    },
    computed: {
        ...mapState("culture", ["cultures"]),
        ...mapState("soil", ["soilTypes"]),
        ...mapState("country", ["countries"]),
        ...mapState("rec", ["tableData"]),
        ...mapState("calculation", ["calculationData", "duplicate", "calculationFilter"]),
        ...mapGetters("calculation", ["getCalculationsOrderedByIndex", "getFilteredCalculations"]),
        recommendationText() {
            return recommendationId => {
                const recommendation = this.rec_data.find(rec => rec.id === recommendationId);
                if (!recommendation) return;
                return recommendation.locale?.en?.text || "";
            };
        }
    },
    async mounted() {
        await this.fetchCalculation();
        await this.fetchRecTableData();
    },

    methods: {
        ...mapActions("rec", ["fetchRecTableData"]),
        ...mapActions("calculation", [
            "fetchCalculation",
            "editCalculation",
            "deleteCalculation",
            "duplicateCalculation",
            "refreshCalculation",
            "clearCalculationFilterDate"
        ]),

        formatDate(date) {
            if (date) {
                return moment(date).format("DD.MM.YY");
            }
            return "-";
        },

        async handleRefreshCalculationClick(id) {
            await this.refreshCalculation(id);
        },
        handleRecommendationItemClick(calculation, item) {
            calculation.recommendation = item.id;
        },

        clearDate(dateType) {
            this.clearCalculationFilterDate(dateType);
        }
    },
    watch: {
        cultures: function() {
            this.tData = this.cultures;
            for (let i = 0; i < this.cultures.length; i++) {
                this.field_culture.push(this.cultures[i].locale.en_culture);
            }
        },
        soilTypes: function() {
            for (let i = 0; i < this.soilTypes.length; i++) {
                this.soils.push(this.soilTypes[i]);
            }
        },
        tableData: function() {
            for (let i = 0; i < this.tableData.length; i++) {
                this.rec_data.push(this.tableData[i]);
            }
        },
        calculationData: function() {
            this.orderedCalculationData = this.getCalculationsOrderedByIndex;
        },

        calculationFilter: {
            handler() {
                this.orderedCalculationData = this.getFilteredCalculations;
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.custom-table-padding td {
    padding-left: 16px;
    padding-right: 16px;
}

.date-to-menu {
    margin: 0;
    padding: 0;
}

.index-textarea {
    width: 8%;
}

.title-padding {
    padding-left: 27px !important;
}

.sensor-width {
    padding: 8px !important;
}

.calculation-title {
    padding-bottom: 25px;
}

.button-position {
    display: table-cell;
    width: 165px;
}

.date_style {
    min-height: 0;
    height: 55px;
    padding: 10px 0;
}

.base-min-width {
    min-width: 165px;
}

.min-width-100 {
    min-width: 100px;
}

.min-width-400 {
    min-width: 400px;
}

.filter-bg {
    background-color: #f5f5f5;
}
</style>
